export default "__VITE_ASSET__mFKIcNzu__"